import React from "react";
import { useNavigate } from "react-router-dom";
import { FaRegEye } from "react-icons/fa";
import Card from "components/card";
import TICKET_STATUSES from "constants/constants";

const HistoryCard = ({ tickets }) => {
  const navigate = useNavigate();
    const userId = localStorage.getItem("id")
  const role = localStorage.getItem("role")
  const handleCardClick = (id) => {
    navigate(`/admin/tickets/${id}`);
  };
  return (
    <Card extra={"mt-3 !z-5 overflow-hidden"}>
      {/* HistoryCard Header */}
      <div className="flex items-center justify-between rounded-t-3xl p-3">
        <div className="text-lg font-bold text-navy-700 dark:text-white">
          Escalated Ticket History
        </div>
        <button className="linear rounded-[20px] bg-lightPrimary px-4 py-2 text-base font-medium text-brand-500 transition duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20">
          See all
        </button>
      </div>

      {/* History CardData */}
      {tickets.filter(ticket => ticket.status === "escalated").length === 0 ? (
        <h5 className="text-base font-medium text-navy-700 dark:text-white ml-5 mb-5">
          No Escaslated Ticket So Far Found
        </h5>
      ) : (
        <>
          {(role === "agent"
                ? tickets.filter((ticket) => ticket.assigned_to === Number(userId))
                : tickets
              ).filter(ticket => ticket.status === "escalated").map((ticket, index) => (
            <div key={index} className="flex h-full w-full items-start justify-between bg-white px-3 py-[20px] hover:shadow-2xl dark:!bg-navy-800 dark:shadow-none dark:hover:!bg-navy-700">
              <div className="flex items-center gap-3">
                <div className="flex flex-col">
                  <h5 className="text-base font-bold text-navy-700 dark:text-white">
                    {ticket.subject}
                  </h5>
                  <p className="mt-1 text-sm font-normal text-gray-600">
                    Assigned To : {ticket.assigned_to_user}
                  </p>
                </div>
              </div>

              <div className="mt-1 flex flex-col items-start justify-center text-navy-700 dark:text-white">
                <div className="flex items-center text-md font-bold text-navy-700 dark:text-white">
                  Status : {(TICKET_STATUSES.find(s => s.value === ticket.status) || {}).label || ticket.status}
                </div>
                <div className="flex items-center text-sm font-normal text-gray-600 dark:text-white mr-5">
                  <p>SLA Breached</p>
                </div>
              </div>
              <button
                onClick={() => handleCardClick(ticket.id)}
                className="flex h-12 w-16 items-center justify-center bg-gray-100 dark:bg-navy-500 rounded-xl cursor-pointer hover:shadow-md transition-shadow duration-300 dark:hover:bg-navy-900">
                <FaRegEye className="w-6 h-6" />
              </button>
            </div>
          ))}
        </>
      )
      }
    </Card>
  );
};

export default HistoryCard;
